import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { Avatar, Badge, Box, ButtonBase, CardActions, ClickAwayListener, Divider, Grid, Paper, Popover, Typography } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import MainCard from 'ui-component/cards/MainCard';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationList from './NotificationList';
import { SET_MODAL_STATUS } from 'store/actions';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_TOTAL_UNREAD_NOTIFICATIONS, MARK_ALL_AS_READ } from 'schemas/query';

const NotificationSection = () => {
    const theme = useTheme();
    const location = useLocation();
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [unreadNotification, setUnreadNotification] = useState(0);
    const [markedAllMessage, setMarkedAllMessage] = useState('');
    const userData = localStorage.getItem('diologUserData');
    const [isAllRead, setAllRead] = useState(true);
    let companyId = '';
    if (userData) {
        let userDataParsed = JSON.parse(userData);
        if (userDataParsed && userDataParsed.companyId) {
            companyId = userDataParsed.companyId;
        }
    }
    const [getTotalNotification] = useLazyQuery(GET_TOTAL_UNREAD_NOTIFICATIONS, {
        onCompleted: (result) => {
            if (result.getUnreadNotificationCount) {
                setUnreadNotification(result.getUnreadNotificationCount.count);
            }
        }
    });
    const [markAllAsRead] = useLazyQuery(MARK_ALL_AS_READ, {
        onCompleted: (result) => {
            if (result.markAllNotificationAsRead) {
                setMarkedAllMessage(result?.markAllNotificationAsRead?.message);
                setAllRead(true);
            }
        }
    });
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const onClickMarkAllRead = () => {
        if (companyId) {
            markAllAsRead({
                variables: {
                    markAllNotificationAsRead: {
                        companyId: companyId
                    }
                }
            });
        }
    };
    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;
    useEffect(() => {
        if (companyId) {
            setTimeout(() => {
                getTotalNotification({
                    variables: {
                        unreadNotificationCount: {
                            companyId: companyId
                        }
                    }
                });
            }, 500);
        }
    }, [location]);
    return (
        <>
            <Box
            // sx={{
            //     ml: 2,
            //     mr: 3,
            //     [theme.breakpoints.down('md')]: {
            //         mr: 1,
            //         ml: 0
            //     }
            // }}
            >
                <ButtonBase sx={{ borderRadius: '12px' }} disableRipple className="header-icon-container" onClick={handleClick}>
                    <Badge
                        badgeContent={unreadNotification}
                        color="secondary"
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                    >
                        <Avatar
                            variant="rounded"
                            className="header-icon"
                            aria-controls={open ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            color="inherit"
                        >
                            <NotificationsIcon sx={{ fontSize: '24px', transform: 'rotate(45deg)' }} />
                        </Avatar>
                    </Badge>
                </ButtonBase>
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                className="dashboard-dropdown"
            >
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                        <MainCard
                            border={false}
                            elevation={16}
                            content={false}
                            boxShadow
                            shadow={theme.shadows[16]}
                            className="notification-box"
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" justifyContent="space-between">
                                        <Grid item xs={!isAllRead ? 6 : 12}>
                                            <Typography variant="h2">Notifications</Typography>
                                        </Grid>
                                        {!isAllRead && (
                                            <Grid item xs={6}>
                                                <Typography
                                                    className="text-right text-underlined text-with-border-at-bottom"
                                                    onClick={onClickMarkAllRead}
                                                >
                                                    Mark all as read
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                                <Divider orientation="horizontal"></Divider>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <PerfectScrollbar
                                                style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}
                                            >
                                                <NotificationList
                                                    handleClose={handleClose}
                                                    message={markedAllMessage}
                                                    setIsAllRead={setAllRead}
                                                    setUnreadNotification={setUnreadNotification}
                                                />
                                            </PerfectScrollbar>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider />
                            <CardActions>
                                <Link to="notifications" onClick={handleClose}>
                                    View all notifications
                                </Link>
                            </CardActions>
                        </MainCard>
                    </ClickAwayListener>
                </Paper>
            </Popover>
        </>
    );
};

export default NotificationSection;
